import { BehaviorSubject, Subject } from 'rxjs';
import { isDetoursEnabled, getLayersForLayertree, isLogosEnabled, isPhotosEnabled, isShootingEnabled, } from '../urlHandling/urlSearchParams.js';
export const meta$ = new BehaviorSubject(undefined);
export const map$ = new BehaviorSubject(undefined);
export const geolocationHelper$ = new BehaviorSubject(undefined);
export const mapElementConnected$ = new BehaviorSubject(false);
export const bgLayer$ = new BehaviorSubject('pk');
export const edittrackMode$ = new BehaviorSubject('');
export const mapClick$ = new Subject();
export const showCoordinates$ = new Subject();
export const visibleLayers$ = new BehaviorSubject(getLayersForLayertree());
export const visibleAdditionalRouteLayers$ = new BehaviorSubject({
    detours: isDetoursEnabled(),
    photos: isPhotosEnabled(),
    logos: isLogosEnabled(),
    shooting: isShootingEnabled(),
});
export const preservedSeasonLayers$ = new BehaviorSubject([]);
export const showPlaceFromSearch$ = new Subject();
//# sourceMappingURL=store-map.js.map